module.exports = __webpack_public_path__ + "static/media/card-open-claw-mobile-br.7d0dd219.png";